import { actions, listsV2 } from '@ecosystem/newron-design-system';
import React from 'react';

import { SelectedRows } from '../types';

const { Button } = actions;

export interface SelectionFooterProps {
  selectedRows: SelectedRows;
  rowSelectionMode: listsV2.RowSelectionMode;
  onCancel: () => void;
  onClearAll: () => void;
  onView: () => void;
}

export const SelectionFooter: React.FC<SelectionFooterProps> = ({
  selectedRows,
  rowSelectionMode,
  onCancel,
  onClearAll,
  onView,
}) => {
  const hasSelectedRows = Object.values(selectedRows)?.some(selectStatus => selectStatus === true);
  const isMultiSelectMode = rowSelectionMode === listsV2.RowSelectionMode.Multiple;

  const handleButtonClick = () => {
    (isMultiSelectMode ? onClearAll : onCancel)();
  };

  return (
    <div className="flex items-center">
      <Button mode="secondary" onClick={handleButtonClick} disabled={isMultiSelectMode && !hasSelectedRows} stretch>
        {isMultiSelectMode ? 'Clear all' : 'Cancel'}
      </Button>
      <Button onClick={onView} disabled={!hasSelectedRows} stretch>
        View
      </Button>
    </div>
  );
};
